import { Avatar, Button, Dialog, DialogContent, Stack, TextField, Typography } from "@mui/material";
import { PopupTransition } from "components/@extended/Transitions";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import React, { useEffect, useState } from "react";
import serverCall from "api/serverCall";
import api from "api/api";
import { Copy } from "iconsax-react";

interface KiteConnectModalProps {
    open: boolean;
    handleCancel: () => void;
}

export const KiteConnectModal: React.FC<KiteConnectModalProps> = ({ open, handleCancel }) => {
    const [url, setUrl] = useState<string>('');

    const handleConnectToMarket = () => {
        serverCall.get(api.getZerodhaLoginUrlAdmin(), (response, error) => {
            if (error) {
                console.error(error);
            } else {
                window.open(response, '_self');
            }
        });
    }

    const handleConnectUsingToken = () => {
        serverCall.get(api.connectToZerodha(), (response, error) => {
            if (error) {
                console.error(error);
            } else {
                const originalUrl = new URL(response as string);
                const redirectUrl =
                    window.location.origin +
                    originalUrl.pathname +
                    originalUrl.search +
                    originalUrl.hash;
                window.open(redirectUrl, '_self');
            }
        })
    }

    const fetchUrl = () => {
        serverCall.get(api.connectToZerodha(), (response, error) => {
            if (error) {
                console.error(error);
            } else {
                const originalUrl = new URL(response as string);
                const redirectUrl =
                    window.location.origin +
                    originalUrl.pathname +
                    originalUrl.search +
                    originalUrl.hash;
                setUrl(redirectUrl);
            }
        })
    }

    useEffect(() => {
        fetchUrl();
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={handleCancel}
            keepMounted
            fullWidth
            TransitionComponent={PopupTransition}
            maxWidth="xs"
            aria-labelledby="kite-confirmation-title"
            aria-describedby="kite-confirmation-description"
        >
            <DialogContent sx={{ mt: 2, my: 1 }}>
                <Stack alignItems="center" spacing={3.5}>
                    <Avatar color="error" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
                        <PowerSettingsNewIcon />
                    </Avatar>
                    <Stack spacing={2}>
                        <Typography variant="h4" align="center">
                            Connect to Kite
                        </Typography>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
                        <Button fullWidth onClick={handleConnectToMarket} color="success" variant="contained">
                            Connect to market
                        </Button>
                        <Button
                            fullWidth
                            color="primary"
                            variant="contained"
                            onClick={handleConnectUsingToken}
                            autoFocus
                        >
                            Connect using token
                        </Button>
                    </Stack>
                </Stack>
                {url && (
                    <Stack sx={{ pt: 2 }} direction={"row"} alignItems="center">

                        <TextField
                            label="Connection URL"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            fullWidth
                        />
                        <Button onClick={() => navigator.clipboard.writeText(url)}>
                            <Copy />
                        </Button>
                    </Stack>
                )}
                <Button
                    fullWidth
                    color="error"
                    variant="outlined"
                    onClick={handleCancel}
                    sx={{ mt: 2 }}
                >
                    Cancel
                </Button>
            </DialogContent>
        </Dialog>
    )
}